import { JiraField } from '@qality/common-model';
import { JqlQueryBuilder } from '@qality/common-utils/src/builders/JqlBuilder';

import { StringUtils } from './index';

const MAX_SEARCH_RESULTS = 50;

const DEFAULT_FIELDS: Array<JiraField> = [
  'summary',
  'issuetype',
  'status',
  'assignee',
  'priority',
  'project',
  'description',
];

const getValidIssueKeysFromText = (text: string) => {
  return StringUtils.removeWhitespace(text)
    .split(',')
    .filter(StringUtils.isValidIssueKey);
};

const buildJqlQuery = (filters, mode: 'text' | 'keys', keys = []) => {
  const builder = new JqlQueryBuilder().where();

  if (mode === 'text') builder.withText(filters.text);
  if (mode === 'keys') builder.withKeys(keys);

  builder
    .withProjects(filters.projects)
    .withStatuses(filters.statuses)
    .withIssueIds(filters.issueIds)
    .endWhere()
    .orderBy(filters.orderBy);

  return builder.build();
};

export const JQLSearchUtils = {
  getValidIssueKeysFromText,
  DEFAULT_FIELDS,
  buildJqlQuery,
  MAX_SEARCH_RESULTS,
};
